import React from "react";

import { useIntl } from "react-intl";

import * as Sticker from "ds/Sticker";
import * as S from "src/organization/pages/project/environment/ConfigureResourcesPage/ConfigureResourcesPage.style";

const InactiveEnvironmentWarning = () => {
  const intl = useIntl();

  return (
    <S.PermissionsStickerRoot priority="normal">
      <Sticker.Icon priority="normal" />
      <Sticker.Text>
        {intl.formatMessage({
          id: "configure_resources.page.inactive.environment.warning",
          defaultMessage:
            "This environment is inactive. Making a change to the resources will also activate this environment."
        })}
      </Sticker.Text>
    </S.PermissionsStickerRoot>
  );
};

export default InactiveEnvironmentWarning;
